<template>
    <div class="customConsult">
        <div class="consult_background">
            <div class="consult_background_img">
                <img src="../../../assets/images/trainServices/consultImg_01.png" alt="">
            </div>
            <div>欢迎</div>
            <div class="consult_background_text">进行培训服务咨询</div>
        </div>
        <div class="consult_form">
            <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm" status-icon >
                <el-row :gutter="24">
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item label="培训主体：" prop="pxzt">
                            <el-select v-model="ruleForm.pxzt" filterable placeholder="请选择培训主体" size="large" no-data-text=暂无数据>
                                <el-option v-for="item in pxztList" :key="item._id" :label="item.pxzt" :value="item._id" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">    
                        <el-form-item label="培训类型：" prop="pxlx">
                            <el-select v-model="ruleForm.pxlx" filterable placeholder="请选择培训类型" size="large" no-data-text=暂无数据>
                                <el-option v-for="item in offlineTitList" :key="item._id" :label="item.pxfl" :value="item._id"/>
                            </el-select>
                        </el-form-item> 
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item label="公司名称：" prop="gsmc">
                            <el-input v-model="ruleForm.gsmc"  placeholder="请输入公司名称" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item label="公司职务：" prop="gszw">
                            <el-input v-model="ruleForm.gszw "  placeholder="请输入公司职务" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item :label="'姓' + '　'.repeat(2) + '名：'" prop="xm">
                            <el-input v-model="ruleForm.xm"  placeholder="请输入姓名" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                        <el-form-item label="手机号码：" prop="lxsjh" >
                            <el-input v-model="ruleForm.lxsjh"  placeholder="请输入联系手机号" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :class="['wui-input-error-color-' + themeColor]" >     
                        <el-form-item label="咨询内容：" prop="zxnr"  >
                            <el-input v-model="ruleForm.zxnr" :autosize="{ minRows: 7, maxRows: 7 }" type="textarea" placeholder="请输入想要咨询的服务内容" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <div :class="['wui-background-color-' + themeColor]" class="btn" @click="submitForm(ruleFormRef)">
                        立即提交咨询
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
 
<script>
import { getCurrentInstance,ref,watch,computed,onMounted,nextTick} from "vue";
export default {
    name: "secondPage",
    props:{
        themeColor: {
            type: String,
            default: 'blue'
        },
        offlineTitList:{
            type:Array,
            default:()=>([])
        }
    },
    setup(props) {
        const { proxy } = getCurrentInstance();
        const pxztList=ref([
            {
                pxzt:'政府培训',
                _id:'政府培训'
            },{
                pxzt:'企业培训',
                _id:'企业培训'
            },{
                pxzt:'个人培训',
                _id:'个人培训'
            }
        ])
        const ruleFormRef=ref(null)
        const ruleForm= ref({pxlx:'',pxzt:'',gsmc:'',gszw:'',xm:'',lxsjh:'',zxnr:''})
        const rules = ref({
            pxzt: [
                { required: true, message: "请选择培训主体", trigger: "change" }
            ],
            pxlx:[
                { required: true, message: "请选择培训类型", trigger: "change" }
            ],
            xm: [
                { required: true, message: "请输入姓名", trigger: "blur" },
            ],   
            lxsjh: [
                { required: true, message: "请输入联系手机号", trigger: "blur" },
            ],
            zxnr: [
                { required: true, message: "请输入咨询内容", trigger: "blur" },
            ],
        })
        const updateTheme = () => {
            document.documentElement.style.setProperty('--el-color-primary', props.themeColor);
        }
        updateTheme()
        //提交表单
        const submitForm = async (formEl) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    addFn()
                } else {
                    console.log('error submit!', fields)
                }
            })
        }
        //保存数据
        const addFn=()=>{ 
            proxy.$request({
                url: "QPSTZX_PXFW_PXFWZXADD",
                method: "post",
                data:ruleForm.value
            }).then((res) => {
                if (res.data.code == "000") {
                    proxy.$message({
                        type: "success",
                        message: "提交成功"
                    });
                    ruleForm.value={}
                    ruleFormRef.value.resetFields();
                }
            }).catch((err) => {
                console.log(err);
            });
        }
       
        onMounted(() => {

        });
        return {
            pxztList,
            ruleForm,
            ruleFormRef,
            rules,
            submitForm,
        };
    },
};
</script>

<style lang="less" scoped>
    .customConsult {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        .consult_background {
            box-sizing: border-box;
            width: 386px;
            height: 456px;
            padding-left: 46px;
            padding-top: 65px;
            background: url(../../../assets/images/trainServices/consultBgImg.png) no-repeat;
            background-size: 100% 100%;
            font-size: 34px;
            line-height: 48px;
            color: #FFFFFF;
            .consult_background_img{
                width: 114px;
                height: 127px;
                margin-bottom: 44px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .consult_background_text{
                margin-top: 9px;
                font-weight: 600;
            }
        }
        .consult_form {
            box-sizing: border-box;
            flex: 1;
            background: #F9FAFC;
            padding: 28px 30px 0 30px;
            /deep/.demo-ruleForm{
                .el-form-item__content{line-height: 40px;}
                .el-input__inner{border-radius: 0;height: 34px;line-height: 40px;height: 40px;}
            }
        }
        .btn {
            width: 134px;
            height: 40px;
            background: #0754BD;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 40px;
            text-align: center;
            cursor:pointer;
        }
    }
</style>